(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["torras-wc-anchor-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Landing gap: where a clicked section's anchor settles below the bar.
     Spy line sits LOWER than the landing gap so the section we just landed on
     is unambiguously "past the line" — this is what keeps click + scrollspy in sync. */
  var GAP_LAND = 12;
  var GAP_LINE = 24;

  function initNav(list) {
    if (!list || list.dataset.wcnInit === '1') return;
    list.dataset.wcnInit = '1';

    var inner = list.closest('.torras-wc-anchornav__inner');
    var links = Array.prototype.slice.call(list.querySelectorAll('.torras-wc-anchornav__link'));
    var sticky = list.getAttribute('data-sticky') === 'true';
    var stickyExtra = parseInt(list.getAttribute('data-sticky-top'), 10) || 0;

    function headerHeight() {
      /* When the page un-stickies the theme header (campaign chrome), it scrolls away and
         never overlaps anchored content — contribute 0 to every scroll offset. */
      try {
        var hs = document.querySelector('.shopify-section--header');
        if (hs) {
          var pos = getComputedStyle(hs).position;
          if (pos !== 'sticky' && pos !== 'fixed') return 0;
        }
        return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      }
      catch (e) { return 0; }
    }
    function barHeight() {
      return (sticky && inner) ? Math.round(inner.getBoundingClientRect().height) : 0;
    }

    /* Publish the global anchor offset so native #jumps (and no-JS) still clear the bar. */
    function publishOffset() {
      if (!inner) return;
      var h = Math.round(inner.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--wc-anchor-offset', (headerHeight() + h + GAP_LAND) + 'px');
    }
    publishOffset();
    try { window.addEventListener('resize', publishOffset, { passive: true }); } catch (e) { window.addEventListener('resize', publishOffset); }

    /* Resolve each link to its target section; hide links whose target isn't on the page. */
    var entries = [];
    links.forEach(function (link) {
      var id = link.getAttribute('data-anchor-target');
      if (!id) return; /* external/URL link — leave as-is, no scrollspy */
      var el = document.getElementById(id);
      var item = link.closest('.torras-wc-anchornav__item');
      if (!el) { if (item) item.setAttribute('hidden', ''); return; }
      entries.push({ link: link, item: item, el: el, id: id });
    });
    if (!entries.length) return;

    var currentLink = null;
    function setActive(activeLink) {
      if (activeLink === currentLink) return;
      currentLink = activeLink;
      links.forEach(function (l) {
        if (l === activeLink) { l.setAttribute('aria-current', 'true'); }
        else { l.removeAttribute('aria-current'); }
      });
      /* On narrow screens, keep the active chip in view within the scrollable bar.
         Scroll ONLY the list's own scrollLeft — scrollIntoView walks the whole scroller
         chain and its smooth animation interrupts the user's in-flight page scroll,
         which made the page feel stuck right at every section boundary. */
      if (activeLink && list.scrollWidth > list.clientWidth) {
        try {
          var lr = list.getBoundingClientRect();
          var ar = activeLink.getBoundingClientRect();
          var left = list.scrollLeft + (ar.left - lr.left) - (lr.width - ar.width) / 2;
          list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } catch (e) {}
      }
    }

    /* ---------------- scrollspy (position-based) ---------------- */
    entries.sort(function (a, b) {
      return (a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });

    function activationLine() {
      if (inner) { var b = inner.getBoundingClientRect().bottom; if (b > 0) return b + GAP_LINE; }
      return GAP_LINE;
    }
    function update() {
      var line = activationLine();
      var current = 0;
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].el.getBoundingClientRect().top - line <= 1) { current = i; }
        else { break; }
      }
      setActive(entries[current].link);
    }

    /* While a click-initiated scroll is in flight the spy is LOCKED on the clicked link,
       so it neither flickers through intermediate sections nor "corrects" the landing.
       Any real user input (wheel / touch / keys) hands control back to the spy. */
    var spyLocked = false;
    var clickSeq = 0;
    function unlock() { spyLocked = false; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      try { window.addEventListener(ev, unlock, { passive: true }); } catch (e) { window.addEventListener(ev, unlock); }
    });

    var ticking = false;
    function onScroll() {
      if (ticking || spyLocked) return;
      ticking = true;
      (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
        if (!spyLocked) update();
        ticking = false;
      });
    }
    try { window.addEventListener('scroll', onScroll, { passive: true }); } catch (e) { window.addEventListener('scroll', onScroll); }
    window.addEventListener('resize', onScroll);
    update();

    /* ---------------- click-to-scroll (JS-driven, direction-aware) ---------------- */

    /* The theme header hides on scroll-down and reveals on scroll-up, which moves the
       sticky bar by the header height mid-scroll. Predict the END state from the scroll
       direction so the section lands exactly GAP_LAND below the bar — then one corrective
       pass against the bar's REAL position absorbs any prediction error. */
    function endOffset(goingDown) {
      return (goingDown ? 0 : headerHeight()) + stickyExtra + barHeight() + GAP_LAND;
    }

    function afterSettle(cb) {
      var done = false, timer = null, max = null;
      function finish() {
        if (done) return;
        done = true;
        clearTimeout(timer); clearTimeout(max);
        window.removeEventListener('scroll', onS);
        window.removeEventListener('scrollend', onE);
        cb();
      }
      function onE() { finish(); }
      function onS() { clearTimeout(timer); timer = setTimeout(finish, 140); }
      if ('onscrollend' in window) window.addEventListener('scrollend', onE, { once: true });
      try { window.addEventListener('scroll', onS, { passive: true }); } catch (e) { window.addEventListener('scroll', onS); }
      timer = setTimeout(finish, 140);   /* settles immediately if no scroll happens at all */
      max = setTimeout(finish, 1500);    /* hard guard */
    }

    function scrollToEntry(entry) {
      var seq = ++clickSeq;
      spyLocked = true;
      setActive(entry.link);

      var reduced = false;
      try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      var behavior = reduced ? 'auto' : 'smooth';

      var targetAbs = entry.el.getBoundingClientRect().top + window.pageYOffset;
      var goingDown = targetAbs - endOffset(true) > window.pageYOffset + 2;
      window.scrollTo({ top: Math.max(0, Math.round(targetAbs - endOffset(goingDown))), behavior: behavior });

      afterSettle(function () {
        if (seq !== clickSeq) return; /* superseded by a newer click */
        /* Corrective passes against the bar's REAL position. Delayed so the header/bar
           0.2s top-transition finishes first (short jumps land while it's mid-flight);
           up to two passes absorb any residue. Spy stays locked on the clicked link. */
        var tries = 0;
        function correct() {
          if (seq !== clickSeq) return;
          var barBottom = inner ? inner.getBoundingClientRect().bottom : 0;
          var diff = Math.round(entry.el.getBoundingClientRect().top - (barBottom + GAP_LAND));
          if (Math.abs(diff) > 4 && tries < 2) {
            tries++;
            window.scrollTo({ top: Math.max(0, window.pageYOffset + diff), behavior: behavior });
            setTimeout(correct, 380);
          }
        }
        setTimeout(correct, 240);
      });
    }

    /* Delegate ALL same-page anchor links that point at our known sections (the nav's own
       chips, but also hero / sticky-bar / announcement CTAs) through the same engine, so
       every jump on the page lands identically and the spy never disagrees with a click. */
    var byId = {};
    entries.forEach(function (e) { byId[e.id] = e; });
    if (!document.documentElement.hasAttribute('data-wcn-delegated')) {
      document.documentElement.setAttribute('data-wcn-delegated', '');
      /* CAPTURE phase: the base theme registers its own document-level delegate for
         a[href*="#"] (preventDefault + scrollIntoView with no header-state awareness) —
         capture lets us claim the click first; the theme's handler then sees
         defaultPrevented and backs off. */
      document.addEventListener('click', function (ev) {
        if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
        if (!a) return;
        var id = (a.getAttribute('href') || '').slice(1);
        var entry = byId[id];
        if (!entry) return;
        ev.preventDefault();
        scrollToEntry(entry);
        try { history.replaceState(null, '', '#' + id); } catch (e) {}
      }, true);
    }
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-wc-anchornav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBar(root){
    if(!root || root.dataset.wcabInit === '1') return;
    root.dataset.wcabInit = '1';

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Dismiss with localStorage ---- */
    if(root.getAttribute('data-dismissible') === 'true'){
      var key = root.getAttribute('data-storage-key');
      try{
        if(key && window.localStorage && window.localStorage.getItem(key) === '1'){
          root.hidden = true;
          return;
        }
      }catch(e){}
      var closeBtn = root.querySelector('[data-wcab-close]');
      if(closeBtn){
        closeBtn.addEventListener('click', function(){
          root.hidden = true;
          try{ if(key && window.localStorage){ window.localStorage.setItem(key, '1'); } }catch(e){}
        });
      }
    }

    /* ---- Countdown ---- */
    var clock = root.querySelector('[data-wcab-clock]');
    var targetStr = root.getAttribute('data-countdown-target');
    var targetMs = targetStr ? Date.parse(targetStr) : NaN;
    if(clock && !isNaN(targetMs)){
      var dEl = root.querySelector('[data-wcab-d]');
      var hEl = root.querySelector('[data-wcab-h]');
      var mEl = root.querySelector('[data-wcab-m]');
      var sEl = root.querySelector('[data-wcab-s]');
      var kickoff = root.querySelector('[data-wcab-kickoff]');
      var label = root.querySelector('[data-wcab-count-label]');
      var pad = function(n){ return (n < 10 ? '0' : '') + n; };
      var timer = null;

      var tick = function(){
        var diff = targetMs - Date.now();
        if(diff <= 0){
          clock.hidden = true;
          if(label) label.hidden = true;
          if(kickoff) kickoff.hidden = false;
          if(timer) clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600);  s -= h * 3600;
        var m = Math.floor(s / 60);    s -= m * 60;
        if(dEl) dEl.textContent = pad(d);
        if(hEl) hEl.textContent = pad(h);
        if(mEl) mEl.textContent = pad(m);
        if(sEl) sEl.textContent = pad(s);
      };
      tick();
      timer = setInterval(tick, 1000);
    }

    /* ---- Rotating messages ---- */
    var msgs = root.querySelectorAll('[data-wcab-msg]');
    if(msgs.length > 1){
      var interval = parseFloat(root.getAttribute('data-rotate-interval')) || 5;
      if(interval < 2) interval = 2;
      var idx = 0;
      setInterval(function(){
        if(document.hidden) return;
        msgs[idx].classList.remove('is-active');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.add('is-active');
      }, interval * 1000);
    }
  }

  function boot(){
    document.querySelectorAll('[data-torras-wcab]').forEach(initBar);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }
  document.addEventListener('shopify:section:load', function(e){
    if(e && e.target){ e.target.querySelectorAll('[data-torras-wcab]').forEach(initBar); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'wc_unlocked_code';
  // Shopify money_format fallback. Built from char codes (123 = open brace, 125 = close brace) so
  // this static JS block contains no literal Liquid-style braces, which the theme linter
  // (StaticStylesheetAndJavascriptTags) would otherwise read as a Liquid variable/tag.
  var DEFAULT_MONEY = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
  var prefersReduced = false;
  try { prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---- money ---- */
  function formatMoney(cents, fmt) {
    cents = Math.round(cents || 0);
    function withCommas(num, decimals) {
      var n = (num / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    fmt = fmt || DEFAULT_MONEY;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withCommas(cents, 2);
        case 'amount_no_decimals': return withCommas(cents, 0).split('.')[0];
        case 'amount_with_comma_separator': return withCommas(cents, 2).replace(/,/g, ' ').replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(cents, 0).split('.')[0].replace(/,/g, '.');
        case 'amount_with_space_separator': return withCommas(cents, 2).replace(/,/g, ' ');
        default: return withCommas(cents, 2);
      }
    });
  }

  /* count-up a money element from its last value to `cents` */
  function setMoney(el, cents, fmt, animate) {
    if (!el) return;
    var from = parseFloat(el.getAttribute('data-cents')) || 0;
    el.setAttribute('data-cents', cents);
    if (!animate || prefersReduced || from === cents) { el.textContent = formatMoney(cents, fmt); return; }
    var t0 = null, dur = 450;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = formatMoney(from + (cents - from) * e, fmt);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function getQueryDiscount() {
    try { var d = new URLSearchParams(window.location.search).get('discount'); return d ? d.trim() : ''; }
    catch (e) { return ''; }
  }
  function getStoredDiscount() {
    try { var v = window.localStorage.getItem(STORAGE_KEY); return v ? v.trim() : ''; } catch (e) { return ''; }
  }
  function sanitize(code) { return (code || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 64); }
  function appendDiscount(url, code) {
    if (!url || !code) return url;
    if (url.indexOf('discount=') !== -1) return url;
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'discount=' + encodeURIComponent(code);
  }

  function initSection(root) {
    if (!root || root.dataset.wcbInit === '1') return;
    root.dataset.wcbInit = '1';

    var fmt = root.getAttribute('data-money-format') || DEFAULT_MONEY;
    var t1pct = parseFloat(root.getAttribute('data-tier1-pct')) || 0;
    var t2pct = parseFloat(root.getAttribute('data-tier2-pct')) || 0;
    var t3pct = parseFloat(root.getAttribute('data-tier3-pct')) || 0;
    var t1name = root.getAttribute('data-t1-name') || 'First Pick';
    var t2name = root.getAttribute('data-t2-name') || 'Link-Up';
    var t3name = root.getAttribute('data-t3-name') || 'Full Squad';
    var ctaLabel = root.getAttribute('data-cta-label') || 'Lock in my squad';
    var ctaEmpty = root.getAttribute('data-cta-empty') || 'Pick your first player';
    var ctaLocked = root.getAttribute('data-cta-locked') || 'Squad locked';

    var lineEls = Array.prototype.slice.call(root.querySelectorAll('[data-wcb-line]'));
    var maxLines = lineEls.length;
    var form = root.querySelector('[data-wcb-form]');
    var itemsBox = root.querySelector('[data-wcb-items]');
    var atc = root.querySelector('[data-wcb-atc]');
    var errEl = root.querySelector('[data-wcb-err]');

    var saveEl = root.querySelector('[data-wcb-save]');
    var payEl = root.querySelector('[data-wcb-pay]');
    var wasTotalEl = root.querySelector('[data-wcb-was-total]');
    var stampEl = root.querySelector('[data-wcb-stamp]');
    var powerEl = root.querySelector('[data-wcb-power]');
    var nudgeEl = root.querySelector('[data-wcb-nudge]');
    var segEls = Array.prototype.slice.call(root.querySelectorAll('[data-wcb-seg]'));
    var segLabelEls = Array.prototype.slice.call(root.querySelectorAll('[data-wcb-seg-label]'));
    var thumbsEl = root.querySelector('[data-wcb-thumbs]');
    var prowEls = Array.prototype.slice.call(root.querySelectorAll('[data-wcb-prow]'));
    var pitchCountEl = root.querySelector('[data-wcb-pitch-count]');
    var xiEl = root.querySelector('[data-wcb-xi]');
    var pitchFootEl = root.querySelector('[data-wcb-pitch-foot]');
    var pitchTierEl = root.querySelector('[data-wcb-pitch-tier]');
    var toastEl = root.querySelector('[data-wcb-toast]');
    var toastBody = root.querySelector('[data-wcb-toast-body]');

    function tierFor(count) {
      if (count <= 0) return { pct: 0, name: t1name };
      if (count === 1) return { pct: t1pct, name: t1name };
      if (count === 2) return { pct: t2pct, name: t2name };
      return { pct: t3pct, name: t3name };
    }

    function selected() {
      // one (or zero) selected button per line, in line order
      var out = [];
      lineEls.forEach(function (line) {
        var b = line.querySelector('[data-wcb-opt].sel');
        if (b) out.push(b);
      });
      return out;
    }

    function buildChip(btn) {
      var thumb = btn.getAttribute('data-thumb');
      var name = btn.getAttribute('data-name') || '';
      var div = document.createElement('div');
      div.className = 'chip';
      div.title = name; // name shown on hover only — no chip label
      div.innerHTML =
        '<div class="chip-wrap"><div class="chip-img">' +
        (thumb ? '<img src="' + thumb + '" alt="">' : '') +
        '</div></div>';
      return div;
    }
    function buildEmpty(prow) {
      var div = document.createElement('div');
      div.className = 'empty-slot';
      var c = document.createElement('div'); c.className = 'empty-circle'; c.textContent = prow.getAttribute('data-code') || '';
      var h = document.createElement('div'); h.className = 'empty-hint'; h.textContent = prow.getAttribute('data-empty-hint') || '';
      div.appendChild(c); div.appendChild(h);
      return div;
    }

    var prevCount = 0;
    var prevSave = 0;

    function recompute(animate) {
      var sel = selected();
      var count = sel.length;
      var subtotal = 0, listTotal = 0;
      sel.forEach(function (b) {
        var p = parseInt(b.getAttribute('data-price'), 10) || 0;
        var c = parseInt(b.getAttribute('data-compare'), 10) || 0;
        subtotal += p;
        listTotal += (c > p ? c : p);
      });
      var tier = tierFor(count);
      var pct = tier.pct;
      var pay = Math.round(subtotal * (1 - pct / 100));
      var save = listTotal - pay;
      if (save < 0) save = 0;

      /* squad power + segments */
      if (powerEl) powerEl.textContent = 'Squad power · ' + count + ' ' + (count === 1 ? 'player' : 'players');
      segEls.forEach(function (seg, i) { seg.classList.toggle('on', count >= (i + 1)); });
      segLabelEls.forEach(function (lab, i) { lab.classList.toggle('on', count >= (i + 1)); });

      /* saved amount (bump on change) */
      if (saveEl) {
        setMoney(saveEl, save, fmt, animate);
        if (animate && save !== prevSave) {
          saveEl.classList.remove('bump'); void saveEl.offsetWidth; saveEl.classList.add('bump');
        }
      }

      /* nudge — quantified reason to add one more line */
      if (nudgeEl) {
        if (count === 0) {
          nudgeEl.hidden = false; nudgeEl.className = 'nudge';
          nudgeEl.innerHTML = '<div class="ghost">+</div><div>Pick your first player — <b>1 pick already gets ' + Math.round(t1pct) + '% off</b>, the squad saves more</div>';
        } else if (count >= maxLines) {
          nudgeEl.hidden = false; nudgeEl.className = 'nudge maxed';
          nudgeEl.innerHTML = '<div class="ghost">✓</div><div><b>' + t3name + ' · ' + Math.round(t3pct) + '% off</b> — max discount locked in</div>';
        } else {
          // count is 1 or 2 (-> the next tier up) on a 3-line build
          var next = tierFor(count + 1);
          // cheapest product in an unfilled line
          var filled = {};
          sel.forEach(function (b) { filled[b.getAttribute('data-line')] = true; });
          var cheapest = Infinity;
          lineEls.forEach(function (line) {
            if (filled[line.getAttribute('data-line-index')]) return;
            line.querySelectorAll('[data-wcb-opt]').forEach(function (b) {
              if (b.disabled) return;
              var p = parseInt(b.getAttribute('data-price'), 10) || 0;
              if (p < cheapest) cheapest = p;
            });
          });
          var extra = 0;
          if (cheapest !== Infinity) {
            extra = (subtotal + cheapest) * (next.pct / 100) - subtotal * (pct / 100);
          }
          nudgeEl.hidden = false; nudgeEl.className = 'nudge';
          nudgeEl.innerHTML = '<div class="ghost">+1</div><div>Add 1 more → unlock <b>' + next.name + ' · ' + Math.round(next.pct) + '% OFF</b>' +
            (extra > 50 ? ' — save <b>' + formatMoney(extra, fmt) + '</b> more' : '') + '</div>';
        }
      }

      /* pitch — fill or empty each row */
      var total = count;
      prowEls.forEach(function (prow) {
        var li = prow.getAttribute('data-line-index');
        var btn = null;
        for (var i = 0; i < sel.length; i++) { if (sel[i].getAttribute('data-line') === li) { btn = sel[i]; break; } }
        prow.innerHTML = '';
        prow.appendChild(btn ? buildChip(btn) : buildEmpty(prow));
      });
      if (pitchCountEl && xiEl) {
        var full = total >= maxLines && maxLines > 0;
        xiEl.hidden = !full;
        pitchCountEl.hidden = full;
        if (!full) pitchCountEl.textContent = total + ' of ' + maxLines + ' positions covered';
      }
      if (pitchFootEl) pitchFootEl.textContent = total === 0 ? (pitchFootEl.getAttribute('data-empty') || 'Your squad is empty — pick a player') : (total + ' in squad');
      if (pitchTierEl) {
        if (total > 0) { pitchTierEl.hidden = false; pitchTierEl.querySelector('b').textContent = tier.name; }
        else pitchTierEl.hidden = true;
      }

      /* checkout — always render one slot PER LINE (reserve all 3) so nothing shifts as picks land */
      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        lineEls.forEach(function (line) {
          var b = line.querySelector('[data-wcb-opt].sel');
          var th = document.createElement('div');
          if (b) {
            th.className = 'thumb';
            var t = b.getAttribute('data-thumb');
            if (t) { var im = document.createElement('img'); im.src = t; im.alt = ''; th.appendChild(im); }
          } else {
            th.className = 'thumb empty';
          }
          thumbsEl.appendChild(th);
        });
      }
      if (payEl) setMoney(payEl, pay, fmt, animate);
      if (wasTotalEl) {
        if (save > 0) { wasTotalEl.textContent = formatMoney(listTotal, fmt); wasTotalEl.hidden = false; }
        else wasTotalEl.hidden = true;
      }
      if (stampEl) {
        if (save > 0) { stampEl.textContent = 'Save ' + formatMoney(save, fmt) + (pct > 0 ? ' · ' + Math.round(pct) + '% off' : ''); stampEl.hidden = false; }
        else stampEl.hidden = true;
      }
      if (atc) {
        if (count === 0) { atc.disabled = true; if (!atc.classList.contains('locked')) atc.textContent = ctaEmpty; }
        else { atc.disabled = false; if (!atc.classList.contains('locked')) atc.textContent = ctaLabel; }
      }

      /* mobile tab counts */
      lineEls.forEach(function (line) {
        var idx = line.getAttribute('data-line-index');
        var cnt = line.querySelector('[data-wcb-opt].sel') ? 1 : 0;
        var badge = root.querySelector('[data-wcb-tab-cnt="' + idx + '"]');
        if (badge) { badge.textContent = cnt; badge.hidden = cnt === 0; }
      });

      /* hidden cart inputs reflect the live selection */
      if (itemsBox) {
        itemsBox.innerHTML = '';
        sel.forEach(function (b, i) {
          var id = document.createElement('input'); id.type = 'hidden';
          id.name = 'items[' + i + '][id]'; id.value = b.getAttribute('data-variant');
          var q = document.createElement('input'); q.type = 'hidden';
          q.name = 'items[' + i + '][quantity]'; q.value = '1';
          itemsBox.appendChild(id); itemsBox.appendChild(q);
        });
      }

      /* tier-unlock toast — only when a discount tier is newly reached */
      if (toastEl && toastBody && count > prevCount && pct > 0) {
        toastBody.innerHTML = '<b>' + tier.name + ' unlocked</b> — ' + Math.round(pct) + '% off everything<small>You are now saving ' + formatMoney(save, fmt) + '</small>';
        toastEl.hidden = false;
        toastEl.classList.remove('toast'); void toastEl.offsetWidth; toastEl.classList.add('toast');
        clearTimeout(root._wcbToastT);
        root._wcbToastT = setTimeout(function () { toastEl.hidden = true; }, 2600);
      }

      prevCount = count;
      prevSave = save;
    }

    /* ---- selection (one per line, deselectable) ---- */
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-wcb-opt]') : null;
      if (!btn || btn.disabled || !root.contains(btn)) return;
      var line = btn.closest('[data-wcb-line]');
      if (!line) return;
      if (btn.classList.contains('sel')) {
        btn.classList.remove('sel'); btn.setAttribute('aria-pressed', 'false');
      } else {
        line.querySelectorAll('[data-wcb-opt].sel').forEach(function (o) {
          o.classList.remove('sel'); o.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('sel'); btn.setAttribute('aria-pressed', 'true');
      }
      if (atc) atc.classList.remove('locked');
      recompute(true);
    });

    /* ---- variant picker -> copy id/price/compare onto the row, refresh its price line ---- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.hasAttribute || !t.hasAttribute('data-wcb-varsel')) return;
      var btn = document.getElementById(t.getAttribute('data-for'));
      var chosen = t.options[t.selectedIndex];
      if (!btn || !chosen) return;
      var p = parseInt(chosen.getAttribute('data-price'), 10) || 0;
      var c = parseInt(chosen.getAttribute('data-compare'), 10) || 0;
      btn.setAttribute('data-variant', t.value);
      btn.setAttribute('data-price', String(p));
      btn.setAttribute('data-compare', String(c));
      var now = btn.querySelector('[data-wcb-now]');
      var was = btn.querySelector('[data-wcb-was]');
      if (now) now.textContent = formatMoney(p, fmt);
      if (was) { if (c > p) { was.textContent = formatMoney(c, fmt); was.hidden = false; } else was.hidden = true; }
      if (!btn.classList.contains('sel')) {
        var line = btn.closest('[data-wcb-line]');
        if (line) line.querySelectorAll('[data-wcb-opt].sel').forEach(function (o) { o.classList.remove('sel'); o.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('sel'); btn.setAttribute('aria-pressed', 'true');
        if (atc) atc.classList.remove('locked');
      }
      recompute(true);
    });

    /* ---- mobile line tabs ---- */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wcb-tab]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-wcb-tab');
        tabs.forEach(function (tb) {
          var on = tb.getAttribute('data-wcb-tab') === idx;
          tb.classList.toggle('active', on); tb.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        lineEls.forEach(function (line) {
          line.classList.toggle('active', line.getAttribute('data-line-index') === idx);
        });
      });
    });

    /* ---- scoreboard countdown (rolling, scoreboard-styled) ---- */
    (function () {
      var box = root.querySelector('[data-wcb-countdown]');
      if (!box) return;
      var mins = parseInt(root.getAttribute('data-countdown-mins'), 10) || 134;
      var KEY = 'wcb-deadline-' + (root.closest('[id]') ? root.closest('[id]').id : 'x');
      var end;
      try { end = parseInt(window.localStorage.getItem(KEY), 10); } catch (e) { end = 0; }
      var now = Date.now();
      if (!end || end < now) { end = now + mins * 60000; try { window.localStorage.setItem(KEY, end); } catch (e) {} }
      var hEl = box.querySelector('[data-wcb-h]'), mEl = box.querySelector('[data-wcb-m]'), sEl = box.querySelector('[data-wcb-s]');
      function pad(x) { return String(x).padStart(2, '0'); }
      function tick() {
        var left = Math.max(0, end - Date.now());
        var s = Math.floor(left / 1000);
        if (hEl) hEl.textContent = pad(Math.floor(s / 3600));
        if (mEl) mEl.textContent = pad(Math.floor((s % 3600) / 60));
        if (sEl) sEl.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ---- game-unlocked discount pill ---- */
    var raw = getQueryDiscount() || getStoredDiscount();
    var code = sanitize(raw);
    if (code) {
      if (getQueryDiscount()) { try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) {} }
      var pill = root.querySelector('[data-wcb-discount]');
      var codeEl = root.querySelector('[data-wcb-discount-code]');
      if (pill && codeEl) { codeEl.textContent = code; pill.classList.add('is-active'); }
    }

    /* ---- submit: AJAX-add every selected variant, then open the cart drawer ---- */
    if (form) {
      var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var cartTypeIsPage = false;
      try { cartTypeIsPage = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page'; } catch (e) {}

      form.addEventListener('submit', function (ev) {
        if (!window.fetch) return; // graceful native POST fallback
        ev.preventDefault();
        if (errEl) errEl.hidden = true;
        var sel = selected();
        if (!sel.length) { if (errEl) errEl.hidden = false; return; }

        var items = sel.map(function (b) { return { id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 }; });
        if (atc) { atc.disabled = true; atc.setAttribute('aria-busy', 'true'); }

        var sections = [];
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
        var payload = { items: items };
        if (sections.length) { payload.sections = sections.join(','); payload.sections_url = window.location.pathname; }

        fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        }).then(function (addJson) {
          if (atc) { atc.classList.add('locked'); atc.removeAttribute('aria-busy'); atc.textContent = ctaLocked; setTimeout(function () { atc.classList.remove('locked'); recompute(false); }, 2200); }
          if (cartTypeIsPage) {
            window.location.href = code ? appendDiscount(shopRoot + 'cart', code) : (shopRoot + 'cart');
            return;
          }
          return fetch(shopRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = addJson.sections;
            var added = addJson.hasOwnProperty('items') ? addJson.items : [addJson];
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            if (atc) { atc.disabled = false; atc.removeAttribute('aria-busy'); }
          });
        }).catch(function () {
          if (atc) { atc.disabled = false; atc.removeAttribute('aria-busy'); atc.classList.remove('locked'); }
          if (errEl) errEl.hidden = false;
        });
      });
    }

    /* silky entrance for the lines block + pitch (CTA/progress stay visible).
       Reveal the always-visible wrappers — never the per-tab line columns, which
       can be display:none on mobile and would stay hidden after autoAlpha:0. */
    if (window.TorrasWCMotion) {
      var revealEls = [root.querySelector('.compact-lines'), root.querySelector('.pitch-card')].filter(Boolean);
      window.TorrasWCMotion.reveal(revealEls, { y: 18, stagger: 0.1, start: 'top 90%' });
    }

    recompute(false);
  }

  function initAll() { document.querySelectorAll('[data-wcb-root]').forEach(initSection); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var el = (e.target && e.target.querySelector) ? e.target.querySelector('[data-wcb-root]') : null;
    if (el) initSection(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-drop-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDropGrid(root) {
    if (!root || root.__wcDropGridInit) return;
    root.__wcDropGridInit = true;

    var moreBtn = root.querySelector('[data-more]');
    var moreWrap = root.querySelector('[data-more-wrap]');
    if (moreBtn && moreWrap) {
      moreBtn.addEventListener('click', function () {
        var hidden = root.querySelectorAll('[data-card].is-hidden');
        for (var i = 0; i < hidden.length; i++) hidden[i].classList.remove('is-hidden');
        moreWrap.classList.add('is-done');
      });
    }

    // Reorder color-matched products first on 'wc:team' event.
    function reorderForTeam(team) {
      if (!team) return;
      var t = String(team).toLowerCase().trim();
      var grid = root.querySelector('.torras-wc-drop-grid__grid');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
      var matched = [];
      var rest = [];
      cards.forEach(function (c) {
        var tags = (c.getAttribute('data-tag') || '').toLowerCase();
        if (tags.split(',').indexOf(t) !== -1 || tags.indexOf(t) !== -1) matched.push(c);
        else rest.push(c);
      });
      matched.concat(rest).forEach(function (c) { grid.appendChild(c); });
    }

    document.addEventListener('wc:team', function (e) {
      var team = e && e.detail && (e.detail.team || e.detail.tag || e.detail);
      reorderForTeam(team);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-torras-wc-drop-grid]');
    for (var i = 0; i < roots.length; i++) initDropGrid(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root) return;
      var video = root.querySelector('[data-torras-wc-hero-video]');
      if (!video) return;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return; // poster only
      }

      var loaded = false;
      function loadVideo() {
        if (loaded) return;
        loaded = true;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var src = (isMobile && video.getAttribute('data-src-mobile')) || video.getAttribute('data-src-desktop') || video.getAttribute('data-src-mobile');
        if (!src) return;
        video.setAttribute('src', src);
        video.load();
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(function () { video.classList.add('is-playing'); }).catch(function () {});
        } else {
          video.classList.add('is-playing');
        }
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadVideo();
              io.disconnect();
            }
          });
        }, { rootMargin: '0px', threshold: 0.1 });
        io.observe(root);
      } else {
        loadVideo();
      }
    }

    function boot() {
      document.querySelectorAll('.torras-wc-hero').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-lead-capture"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.wclcInit === '1') return;
    root.dataset.wclcInit = '1';

    var form = root.querySelector('.torras-wclc-form');
    if (!form) return;
    var email = form.querySelector('input[type="email"]');
    var sms = form.querySelector('input[name="contact[accepts_sms]"]');
    var phone = form.querySelector('input[type="tel"]');
    var submit = form.querySelector('[data-wclc-submit]');

    form.addEventListener('submit', function (e) {
      // Native validation handles the required email; only guard the SMS/phone pairing.
      if (sms && sms.checked && phone && !phone.value.trim()) {
        e.preventDefault();
        phone.setAttribute('required', 'required');
        phone.setAttribute('aria-invalid', 'true');
        if (phone.reportValidity) phone.reportValidity();
        phone.focus();
        return;
      }
      if (submit) { submit.setAttribute('aria-busy', 'true'); }
    });

    if (phone) {
      phone.addEventListener('input', function () {
        if (phone.value.trim()) phone.removeAttribute('aria-invalid');
      });
    }
    if (sms && phone) {
      sms.addEventListener('change', function () {
        if (!sms.checked) { phone.removeAttribute('required'); phone.removeAttribute('aria-invalid'); }
      });
    }
  }

  function boot() {
    document.querySelectorAll('.torras-wc-lead-capture[data-wclc-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-lineup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var prefersReduced = false;
  try { prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Re-stagger the cards of a panel when its tab is activated (immediate, in-view replay). */
  function animatePanel(panel) {
    if (!panel || prefersReduced || !window.gsap) return;
    var cards = panel.querySelectorAll('.torras-wc-lineup__card');
    if (!cards.length) return;
    window.gsap.fromTo(cards,
      { autoAlpha: 0, y: 14 },
      { autoAlpha: 1, y: 0, duration: 0.4, ease: 'power2.out', stagger: 0.05, overwrite: true });
  }

  function initLineup(tablist) {
    if (!tablist || tablist.dataset.wclInit === '1') return;
    tablist.dataset.wclInit = '1';

    var root = tablist.closest('.torras-wc-lineup') || tablist.parentNode;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function panelFor(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? (root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id))
        || document.getElementById(id)) : null;
    }

    function select(tab, focus) {
      var activePanel = null;
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
        var panel = panelFor(t);
        if (panel) {
          if (selected) { panel.removeAttribute('hidden'); activePanel = panel; }
          else { panel.setAttribute('hidden', ''); }
        }
      });
      if (activePanel) { animatePanel(activePanel); }
      if (focus) { tab.focus(); }
    }

    /* Silky entrance: cascade the header, tab bar and first row of cards in on scroll. */
    if (window.TorrasWCMotion) {
      var revealEls = [];
      var head = root.querySelector('.torras-wc-lineup__head');
      if (head) { revealEls.push(head); }
      revealEls.push(tablist);
      var firstPanel = panelFor(tabs[0]);
      if (firstPanel) {
        var firstCards = firstPanel.querySelectorAll('.torras-wc-lineup__card');
        for (var c = 0; c < firstCards.length; c++) { revealEls.push(firstCards[c]); }
      }
      window.TorrasWCMotion.reveal(revealEls, { y: 20, stagger: 0.07, start: 'top 88%' });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var idx = i;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { idx = (i + 1) % tabs.length; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { idx = (i - 1 + tabs.length) % tabs.length; }
        else if (e.key === 'Home') { idx = 0; }
        else if (e.key === 'End') { idx = tabs.length - 1; }
        else { return; }
        e.preventDefault();
        select(tabs[idx], true);
      });
    });
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-wc-lineup]').forEach(initLineup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-predictor"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.wcpInit === '1') return;
    root.dataset.wcpInit = '1';

    var STORE_KEY = 'ygWcPredictor:' + (root.id || 'default');
    var GATE_KEY = 'ygWcPredictorGate';

    function load() {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
    }
    function save(data) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
    }
    function gatePassed() {
      try { return localStorage.getItem(GATE_KEY) === '1'; } catch (e) { return false; }
    }
    function setGatePassed() {
      try { localStorage.setItem(GATE_KEY, '1'); } catch (e) {}
    }

    var state = load();
    var modal = root.querySelector('[data-wcp-modal]');
    var pendingCard = null;

    /* ---------- modal ---------- */
    var lastFocus = null;
    function openModal(card) {
      if (!modal) return;
      pendingCard = card;
      lastFocus = document.activeElement;
      modal.dataset.open = 'true';
      var first = modal.querySelector('input, button, [href]');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }
    function closeModal() {
      if (!modal) return;
      modal.dataset.open = 'false';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKeydown(e) { if (e.key === 'Escape') closeModal(); }

    if (modal) {
      modal.querySelectorAll('[data-wcp-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      var form = modal.querySelector('[data-wcp-gate-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.querySelector('input[name="email"]');
          var phone = form.querySelector('input[name="phone"]');
          var age = form.querySelector('input[name="age_gate"]');
          var err = modal.querySelector('[data-wcp-gate-error]');
          var ok = email && email.value && email.checkValidity() && phone && phone.value && age && age.checked;
          if (!ok) { if (err) err.dataset.show = 'true'; return; }
          if (err) err.dataset.show = 'false';
          setGatePassed();
          var card = pendingCard;
          closeModal();
          if (card) lockCard(card);
        });
      }
    }

    /* ---------- cards ---------- */
    function cardState(card, st) {
      card.dataset.state = st;
    }

    function renderCard(card) {
      var id = card.dataset.matchId;
      var rec = state[id] || {};
      // scores
      ['a', 'b'].forEach(function (side) {
        var el = card.querySelector('[data-wcp-score="' + side + '"]');
        if (el) el.textContent = String(rec['score_' + side] || 0);
      });
      // pick
      card.querySelectorAll('[data-wcp-pick]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.wcpPick === rec.pick ? 'true' : 'false');
      });
      // state
      if (rec.scored === 'correct') cardState(card, 'scored-correct');
      else if (rec.scored === 'wrong') cardState(card, 'scored-wrong');
      else if (rec.locked) cardState(card, 'locked');
      else if (rec.pick || rec.score_a || rec.score_b) cardState(card, 'in-progress');
      else cardState(card, 'empty');
    }

    function lockCard(card) {
      if (!gatePassed()) { openModal(card); return; }
      var id = card.dataset.matchId;
      var rec = state[id] || {};
      rec.locked = true;
      state[id] = rec;
      save(state);
      renderCard(card);
      startCountdown(card);
    }

    function startCountdown(card) {
      var iso = card.dataset.kickoff;
      var out = card.querySelector('[data-wcp-countdown]');
      if (!iso || !out) return;
      var target = new Date(iso).getTime();
      if (isNaN(target)) return;
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { out.textContent = '0d 00h 00m'; return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        function p(n) { return (n < 10 ? '0' : '') + n; }
        out.textContent = d + 'd ' + p(h) + 'h ' + p(m) + 'm';
        card._wcpTimer = setTimeout(tick, 30000);
      }
      tick();
    }

    root.querySelectorAll('[data-wcp-card]').forEach(function (card) {
      var id = card.dataset.matchId;
      state[id] = state[id] || {};

      // steppers
      card.querySelectorAll('[data-wcp-stepper]').forEach(function (stepper) {
        var side = stepper.getAttribute('data-wcp-stepper');
        var valEl = stepper.querySelector('[data-wcp-score="' + side + '"]');
        stepper.querySelector('[data-wcp-inc]').addEventListener('click', function () {
          var rec = state[id]; var v = (rec['score_' + side] || 0) + 1;
          rec['score_' + side] = v; save(state);
          if (valEl) valEl.textContent = String(v); renderCard(card);
        });
        stepper.querySelector('[data-wcp-dec]').addEventListener('click', function () {
          var rec = state[id]; var v = Math.max(0, (rec['score_' + side] || 0) - 1);
          rec['score_' + side] = v; save(state);
          if (valEl) valEl.textContent = String(v); renderCard(card);
        });
      });

      // picks
      card.querySelectorAll('[data-wcp-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[id].pick = btn.dataset.wcpPick; save(state); renderCard(card);
        });
      });

      // lock
      var lockBtn = card.querySelector('[data-wcp-lock]');
      if (lockBtn) lockBtn.addEventListener('click', function () { lockCard(card); });

      renderCard(card);
      if ((state[id] || {}).locked) startCountdown(card);
    });
  }

  function boot() {
    document.querySelectorAll('.torras-wc-predictor').forEach(function (root) {
      var sec = root.closest('[id^="shopify-section-"]') || root;
      initSection(sec.querySelector('.torras-wc-predictor') ? root : root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.wcpInit === '1') return;
    root.dataset.wcpInit = '1';

    var demo = root.querySelector('[data-wcp-demo]');
    if (!demo) return;
    var video = demo.querySelector('video');
    var playBtn = demo.querySelector('[data-wcp-play]');
    if (!video) return;

    function hydrateSources() {
      if (video.dataset.wcpHydrated === '1') return;
      video.dataset.wcpHydrated = '1';
      var sources = video.querySelectorAll('source[data-src]');
      sources.forEach(function (src) {
        if (src.getAttribute('src')) return;
        src.setAttribute('src', src.getAttribute('data-src'));
      });
      video.load();
    }

    function playVideo() {
      hydrateSources();
      demo.classList.add('is-playing');
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    }

    if (playBtn) {
      playBtn.addEventListener('click', playVideo);
    } else {
      // No poster overlay → hydrate sources once the frame is near the viewport.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { hydrateSources(); obs.disconnect(); }
          });
        }, { rootMargin: '200px' });
        io.observe(demo);
      } else {
        hydrateSources();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.torras-wc-proof').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.torras-wc-proof') || (e.target.classList && e.target.classList.contains('torras-wc-proof') ? e.target : null);
    if (el) initSection(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-ring-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRingStory(root) {
    if (!root || root.dataset.rsInit === '1') return;
    root.dataset.rsInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var beats = Array.prototype.slice.call(root.querySelectorAll('[data-rs-beat]'));
    if (!beats.length) return;

    if (reduce) {
      beats.forEach(function (b) { b.classList.add('is-in'); });
      return;
    }

    root.classList.add('rs-js');

    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-rs-frame]'));
    function activate(idx) {
      beats.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      frames.forEach(function (f, i) { f.classList.toggle('is-active', i === idx); });
    }

    // Fade-in for mobile/stacked layout
    var fadeIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); fadeIO.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    beats.forEach(function (b) { fadeIO.observe(b); });

    // Active-beat tracking drives the sticky stage cross-fade (desktop+motion)
    var activeIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = parseInt(e.target.getAttribute('data-rs-beat'), 10) || 0;
          activate(idx);
          // lazily start the matching video if present
          var vid = root.querySelector('[data-rs-frame="' + idx + '"] video');
          if (vid && vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
        }
      });
    }, { threshold: 0.5, rootMargin: '-40% 0px -40% 0px' });
    beats.forEach(function (b) { activeIO.observe(b); });

    activate(0);
  }

  function boot() {
    document.querySelectorAll('[data-rs-root]').forEach(initRingStory);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-rs-root]');
    if (r) initRingStory(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-risk"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n){ return (n < 10 ? '0' : '') + n; }

  function initCountdown(el) {
    if (!el || el.dataset.wcrInit === '1') return;
    el.dataset.wcrInit = '1';

    var raw = el.getAttribute('data-target');
    if (!raw) return;
    var target = new Date(raw).getTime();
    if (isNaN(target)) return;

    var ended = el.parentNode ? el.parentNode.querySelector('[data-wcr-ended]') : null;
    var dEl = el.querySelector('[data-cd-days]');
    var hEl = el.querySelector('[data-cd-hours]');
    var mEl = el.querySelector('[data-cd-mins]');
    var sEl = el.querySelector('[data-cd-secs]');
    var timer = null;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        if (ended) ended.hidden = false;
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }
      var secs = Math.floor(diff / 1000);
      var days = Math.floor(secs / 86400); secs -= days * 86400;
      var hours = Math.floor(secs / 3600); secs -= hours * 3600;
      var mins = Math.floor(secs / 60); secs -= mins * 60;
      if (dEl) dEl.textContent = days;
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.torras-wc-risk [data-wcr-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-spin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpin(root) {
      if (!root || root.__ygSpinInit) return;
      root.__ygSpinInit = true;

      var sectionId = root.getAttribute('data-section-id');
      var wheel = root.querySelector('[data-wheel]');
      var segs = Array.prototype.slice.call(root.querySelectorAll('.torras-wc-spin__seg'));
      if (!wheel || !segs.length) return;

      var openBtn = root.querySelector('[data-open-gate]');
      var form = root.querySelector('[data-gate-form]');
      var errorEl = root.querySelector('[data-error]');
      var wonTitle = root.querySelector('[data-won-title]');
      var wonPrize = root.querySelector('[data-won-prize]');
      var wonCode = root.querySelector('[data-won-code]');
      var savedCodeEl = root.querySelector('[data-saved-code]');
      var countdownEl = root.querySelector('[data-countdown]');
      var applyCtas = Array.prototype.slice.call(root.querySelectorAll('[data-apply-cta]'));

      var baseUrl = root.getAttribute('data-base-url') || '/discount/{CODE}';
      var redirectTo = root.getAttribute('data-redirect') || '';
      var cooldownHours = parseFloat(root.getAttribute('data-cooldown-hours')) || 24;
      var errEmailMsg = root.getAttribute('data-err-email') || 'Please enter a valid email address.';
      var errPhoneMsg = root.getAttribute('data-err-phone') || 'Please enter a valid mobile number.';
      var errConsentMsg = root.getAttribute('data-err-consent') || 'Please tick all boxes (email, SMS and 18+) to continue.';
      var storeKey = 'ygWcSpin_' + sectionId;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setState(s) { root.setAttribute('data-state', s); }

      function buildHref(code) {
        var url = baseUrl.replace('{CODE}', encodeURIComponent(code));
        if (redirectTo) {
          url += (url.indexOf('?') > -1 ? '&' : '?') + 'redirect=' + encodeURIComponent(redirectTo);
        }
        return url;
      }

      function readStore() {
        try { return JSON.parse(localStorage.getItem(storeKey) || 'null'); } catch (e) { return null; }
      }
      function writeStore(obj) {
        try { localStorage.setItem(storeKey, JSON.stringify(obj)); } catch (e) {}
      }

      // weighted pick
      function pickIndex() {
        var total = 0, weights = segs.map(function (s) {
          var w = parseFloat(s.getAttribute('data-weight')) || 1;
          if (w < 0) w = 0;
          total += w;
          return w;
        });
        if (total <= 0) return Math.floor(Math.random() * segs.length);
        var r = Math.random() * total, acc = 0;
        for (var i = 0; i < weights.length; i++) {
          acc += weights[i];
          if (r <= acc) return i;
        }
        return segs.length - 1;
      }

      function revealWon(seg) {
        var code = seg.getAttribute('data-code') || '';
        var label = seg.getAttribute('data-label') || '';
        if (wonPrize) wonPrize.textContent = label;
        if (wonCode) wonCode.textContent = code;
        if (savedCodeEl) savedCodeEl.textContent = code;
        var href = buildHref(code);
        applyCtas.forEach(function (a) { a.setAttribute('href', href); });
      }

      function showCooldown(saved) {
        if (saved) revealWon({
          getAttribute: function (k) {
            return k === 'data-code' ? saved.code : (k === 'data-label' ? saved.label : '');
          }
        });
        setState('cooldown');
        startCountdown(saved ? saved.next : Date.now());
      }

      var cdTimer = null;
      function startCountdown(nextTs) {
        if (!countdownEl) return;
        function tick() {
          var diff = nextTs - Date.now();
          if (diff <= 0) {
            clearInterval(cdTimer);
            countdownEl.textContent = '00:00:00';
            setState('ready');
            return;
          }
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          countdownEl.textContent = [h, m, s].map(function (n) { return n < 10 ? '0' + n : '' + n; }).join(':');
        }
        tick();
        cdTimer = setInterval(tick, 1000);
      }

      function doSpin() {
        var idx = pickIndex();
        var seg = segs[idx];
        var n = segs.length;
        var slice = 360 / n;
        // segment idx center angle measured clockwise from top; pointer is at top (0deg).
        // wheel seg starts at idx*slice; center at +slice/2. To bring center under pointer rotate by -(center).
        var center = idx * slice + slice / 2;
        var target = (360 - center) % 360;

        if (reduceMotion) {
          wheel.style.transition = 'none';
          wheel.style.transform = 'rotate(' + target + 'deg)';
          finishSpin(seg);
          return;
        }

        var spins = 5;
        var finalRot = spins * 360 + target;
        wheel.style.transition = '';
        // force reflow then animate
        void wheel.offsetWidth;
        wheel.style.transform = 'rotate(' + finalRot + 'deg)';

        var done = false;
        function onEnd() {
          if (done) return;
          done = true;
          wheel.removeEventListener('transitionend', onEnd);
          finishSpin(seg);
        }
        wheel.addEventListener('transitionend', onEnd);
        setTimeout(onEnd, 5400); // fallback
      }

      function finishSpin(seg) {
        revealWon(seg);
        var next = Date.now() + cooldownHours * 3600000;
        writeStore({
          code: seg.getAttribute('data-code') || '',
          label: seg.getAttribute('data-label') || '',
          next: next
        });
        setState('won');
      }

      // wire up
      if (openBtn) {
        openBtn.addEventListener('click', function () {
          var saved = readStore();
          if (saved && saved.next && saved.next > Date.now()) { showCooldown(saved); return; }
          setState('gated');
        });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (errorEl) errorEl.textContent = '';
          var email = form.querySelector('input[name="email"]');
          var phone = form.querySelector('input[name="phone"]');
          var consents = Array.prototype.slice.call(form.querySelectorAll('[data-required-consent]'));

          if (!email || !email.value || !/.+@.+\..+/.test(email.value)) {
            if (errorEl) errorEl.textContent = errEmailMsg;
            return;
          }
          if (!phone || phone.value.replace(/\D/g, '').length < 6) {
            if (errorEl) errorEl.textContent = errPhoneMsg;
            return;
          }
          var allChecked = consents.every(function (c) { return c.checked; });
          if (!allChecked) {
            if (errorEl) errorEl.textContent = errConsentMsg;
            return;
          }
          setState('spinning');
          window.setTimeout(doSpin, 150);
        });
      }

      // initial cooldown check
      var saved = readStore();
      if (saved && saved.next && saved.next > Date.now()) {
        showCooldown(saved);
      } else {
        setState('ready');
      }
    }

    function boot() {
      document.querySelectorAll('.torras-wc-spin[data-section-id]').forEach(initSpin);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.wcsInit === '1') return;
    root.dataset.wcsInit = '1';

    var bar = root.querySelector('[data-wcs-bar]');
    var sentinel = root.querySelector('[data-wcs-sentinel]');
    var spacer = root.querySelector('[data-wcs-spacer]');
    var closeBtn = root.querySelector('[data-wcs-close]');
    if (!bar) return;

    var revealAfter = parseInt(bar.getAttribute('data-reveal-after'), 10) || 0;
    var hideNearFooter = bar.getAttribute('data-hide-near-footer') === 'true';
    var footerSelector = bar.getAttribute('data-footer-selector') || 'footer';
    var dismissible = bar.getAttribute('data-dismissible') === 'true';
    var dismissed = false;
    var storeKey = 'ygwc-sticky-dismissed-' + (root.id || 'cta');

    try {
      if (dismissible && sessionStorage.getItem(storeKey) === '1') { dismissed = true; }
    } catch (e) {}

    function setVisible(v) {
      if (dismissed) v = false;
      bar.classList.toggle('is-visible', v);
      if (spacer) spacer.setAttribute('data-active', v ? 'true' : 'false');
    }

    // Keep bar height in sync so the mobile spacer reserves the right room.
    function syncHeight() {
      var h = bar.offsetHeight;
      if (h) root.style.setProperty('--wcs-bar-h', h + 'px');
    }

    // Determine reveal trigger. Prefer a scroll-threshold; combine with footer overlap check.
    var footerEl = null;
    if (hideNearFooter) {
      try { footerEl = document.querySelector(footerSelector); } catch (e) { footerEl = null; }
    }

    /* Elements the bar must yield to (e.g. the bundle's own sticky summary) — when any
       of them is on screen the bar hides instead of stacking on top of it. */
    var avoidEls = [];
    var avoidSelector = bar.getAttribute('data-avoid-selector') || '';
    if (avoidSelector) {
      try { avoidEls = Array.prototype.slice.call(document.querySelectorAll(avoidSelector)); } catch (e) { avoidEls = []; }
    }

    /* Scroll-direction gate: reading down = bar tucks away (full-width content, no
       distraction); scrolling back up or pausing = shopping intent, bar slides in. */
    var hideOnDown = bar.getAttribute('data-hide-on-down') !== 'false';
    var lastY = window.scrollY || window.pageYOffset || 0;
    var scrollingDown = false;
    var idleTimer = null;

    var ticking = false;
    function evaluate() {
      ticking = false;
      if (dismissed) { setVisible(false); return; }

      var pastThreshold = true;
      if (revealAfter > 0) {
        pastThreshold = (window.scrollY || window.pageYOffset || 0) >= revealAfter;
      }

      var vh = window.innerHeight || document.documentElement.clientHeight;

      var nearFooter = false;
      if (footerEl) {
        var rect = footerEl.getBoundingClientRect();
        // Hide once the footer starts entering the viewport.
        if (rect.top < vh) nearFooter = true;
      }

      /* Yield only while the avoided element actually occupies the bar's bottom zone
         (e.g. the bundle summary pinned by its sticky bottom). Once the user scrolls
         past and it travels up with the page, the bar comes back. */
      var overlapsAvoided = false;
      var barZone = vh - (bar.offsetHeight || 76) - 12;
      for (var i = 0; i < avoidEls.length; i++) {
        var ar = avoidEls[i].getBoundingClientRect();
        if (ar.height > 0 && ar.top < vh && ar.bottom > barZone) { overlapsAvoided = true; break; }
      }

      setVisible(pastThreshold && !nearFooter && !overlapsAvoided && !(hideOnDown && scrollingDown));
    }

    function onScroll() {
      if (hideOnDown) {
        var y = window.scrollY || window.pageYOffset || 0;
        var delta = y - lastY;
        lastY = y;
        /* 3px dead-zone absorbs momentum jitter / overscroll bounce. */
        if (delta > 3) scrollingDown = true;
        else if (delta < -3) scrollingDown = false;
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () { scrollingDown = false; evaluate(); }, 240);
      }
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(evaluate);
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        setVisible(false);
        try { sessionStorage.setItem(storeKey, '1'); } catch (e) {}
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { syncHeight(); evaluate(); }, { passive: true });

    syncHeight();
    evaluate();
  }

  function initAll() {
    document.querySelectorAll('.torras-wc-sticky-cta').forEach(function (root) {
      // root here is the spacer/sentinel wrapper context; use the section element instead.
    });
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (sec) {
      if (sec.querySelector('[data-wcs-bar]')) initSection(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-wcs-bar]')) {
      initSection(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-wc-team-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.__tpInit) return;
    root.__tpInit = true;

    var storageKey = root.getAttribute('data-storage-key') || 'wc-team';
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-team-chip]'));
    if (!chips.length) return;

    var docEl = document.documentElement;

    function applyTokens(chip) {
      var accent = chip.getAttribute('data-accent');
      var accentDeep = chip.getAttribute('data-accent-deep');
      var secondary = chip.getAttribute('data-secondary');
      if (accent) docEl.style.setProperty('--wc-accent', accent);
      if (accentDeep) docEl.style.setProperty('--wc-accent-deep', accentDeep);
      if (secondary) docEl.style.setProperty('--wc-secondary', secondary);
    }

    function markActive(chip) {
      chips.forEach(function (c) {
        var on = c === chip;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
    }

    function select(chip, persist, emit) {
      if (!chip) return;
      applyTokens(chip);
      markActive(chip);
      var detail = {
        code: chip.getAttribute('data-code') || '',
        name: chip.getAttribute('data-name') || '',
        accent: chip.getAttribute('data-accent') || '',
        accentDeep: chip.getAttribute('data-accent-deep') || '',
        secondary: chip.getAttribute('data-secondary') || '',
        productTag: chip.getAttribute('data-product-tag') || '',
        licensed: chip.getAttribute('data-licensed') === '1'
      };
      if (persist) {
        try { localStorage.setItem(storageKey, detail.code); } catch (e) {}
      }
      if (emit) {
        try { document.dispatchEvent(new CustomEvent('wc:team', { detail: detail })); } catch (e) {}
      }
    }

    chips.forEach(function (chip, i) {
      chip.tabIndex = i === 0 ? 0 : -1;
      chip.addEventListener('click', function () { select(chip, true, true); });
      chip.addEventListener('keydown', function (e) {
        var idx = chips.indexOf(chip);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var next = chips[(idx + 1) % chips.length]; next.focus(); select(next, true, true);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = chips[(idx - 1 + chips.length) % chips.length]; prev.focus(); select(prev, true, true);
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault(); select(chip, true, true);
        }
      });
    });

    // Restore saved team, else default-flagged chip, else first.
    var restored = null;
    try {
      var saved = localStorage.getItem(storageKey);
      if (saved) {
        restored = chips.filter(function (c) { return c.getAttribute('data-code') === saved; })[0] || null;
      }
    } catch (e) {}
    if (!restored) {
      restored = chips.filter(function (c) { return c.getAttribute('data-default') === '1'; })[0] || chips[0];
    }
    // emit on load so listeners hydrate; persist only if it was already saved
    select(restored, false, true);

    // Soft email gate
    var toggle = root.querySelector('[data-gate-toggle]');
    var form = root.querySelector('[data-gate-form]');
    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var open = form.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var inp = form.querySelector('input[type="email"]'); if (inp) inp.focus(); }
      });

      var pill = form.querySelector('[data-gate-success]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]');
        var consent = form.querySelector('input[type="checkbox"]');
        if (!email || !email.value || !email.checkValidity()) { if (email) email.focus(); return; }
        if (!consent || !consent.checked) { if (consent) consent.focus(); return; }
        var active = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0];
        try {
          document.dispatchEvent(new CustomEvent('wc:team-save', {
            detail: {
              email: email.value,
              consent: true,
              team: active ? active.getAttribute('data-code') : ''
            }
          }));
        } catch (err) {}
        if (pill) pill.classList.add('is-visible');
        var submitBtn = form.querySelector('[data-gate-submit]');
        if (submitBtn) submitBtn.disabled = true;
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-tp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-tp]') : null;
    if (el) initSection(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-awards-box-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSection(section) {
      if (!section || section.dataset.awardsV2Ready === 'true') {
        return;
      }

      const card = section.querySelector('[data-awards-card]');
      const button = section.querySelector('[data-show-more-btn]');
      const wrap = section.querySelector('[data-show-more-wrap]');

      if (!card || !button || !wrap) {
        section.dataset.awardsV2Ready = 'true';
        return;
      }

      const items = card.querySelectorAll('.award-item');
      if (items.length <= 6) {
        wrap.style.display = 'none';
      }

      button.addEventListener('click', () => {
        card.classList.add('is-expanded');
        wrap.style.display = 'none';
      });

      section.dataset.awardsV2Ready = 'true';
    }

    function initAll() {
      document.querySelectorAll('[data-awards-v2-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collapse-text"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collapsible-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('details-accordion')) {
    customElements.define(
      'details-accordion',
      class DetailsAccordion extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          this.el = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.content = this.summary.nextElementSibling;

          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;

          if (!this.dataset.ignoreSetupEvent) {
            this.setupEventListener();
          }
        }

        setupEventListener() {
          this.onClickSummaryHandler = this.onClick.bind(this);
          this.summary.addEventListener('click', this.onClickSummaryHandler);
        }

        onClick(e) {
          e.preventDefault();
          this.toggleContent();
        }

        toggleContent() {
          this.el.style.overflow = 'hidden';
          if (this.isClosing || !this.el.open) {
            this.open();
          } else if (this.isExpanding || this.el.open) {
            this.shrink();
          }
          if (this.dataset.ignoreSetupEvent) {
            return false;
          }
        }

        disconnectedCallback() {
          this.summary.removeEventListener('click', this.onClickSummaryHandler);
        }

        shrink() {
          if (this.dataset.ignoreSetupEvent) {
            this.querySelector('summary').setAttribute('aria-expanded', false);
          } else {
            this.summary.setAttribute('aria-expanded', false);
          }
          this.isClosing = true;

          const startHeight = `${this.el.offsetHeight}px`;
          let endHeight;
          if (this.dataset.ignoreSetupEvent) {
            endHeight = `${this.querySelector('summary').offsetHeight}px`;
          } else {
            endHeight = `${this.summary.offsetHeight}px`;
          }

          if (this.animation) {
            this.animation.cancel();
          }
          this.animation = this.el.animate(
            {
              height: [startHeight, endHeight],
            },
            {
              duration: 400,
              easing: 'ease-out',
            }
          );

          this.animation.onfinish = () => this.onAnimationFinish(false);
          this.animation.oncancel = () => (this.isClosing = false);
        }

        open() {
          this.el.style.height = `${this.el.offsetHeight}px`;
          this.el.open = true;
          window.requestAnimationFrame(() => this.expand());
        }

        expand() {
          this.isExpanding = true;
          const startHeight = `${this.el.offsetHeight}px`;
          let endHeight;
          if (this.dataset.ignoreSetupEvent) {
            this.querySelector('summary').setAttribute('aria-expanded', true);
            endHeight = `${
              this.querySelector('summary').offsetHeight + this.querySelector('summary').nextElementSibling.offsetHeight
            }px`;
          } else {
            this.summary.setAttribute('aria-expanded', true);
            endHeight = `${this.summary.offsetHeight + this.summary.nextElementSibling.offsetHeight}px`;
          }

          if (this.animation) {
            this.animation.cancel();
          }

          this.animation = this.el.animate(
            {
              height: [startHeight, endHeight],
            },
            {
              duration: 400,
              easing: 'ease-out',
            }
          );
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => (this.isExpanding = false);
        }

        onAnimationFinish(open) {
          this.el.open = open;
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.el.style.height = this.el.style.overflow = '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGMediaSwiper extends (typeof YGUtils === 'undefined' ? HTMLElement : YGUtils) {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.isMobileMedia = window.matchMedia('(max-width: 699px)');
      this.slides = Array.from(this.querySelectorAll('.yg-ms__slide'));
      this.setIndicatorAreaByViewport();
      this.hoverTabs = false;
      this.pausedByUser = false;
      this.timerDuration = 0;
      this.remainingDuration = 0;
      this.tickId = null;
      this.startStamp = 0;

      const swiperEl = this.querySelector('.yg-ms__swiper');
      if (!swiperEl || this.slides.length <= 1 || typeof Swiper === 'undefined') {
        this.bindEvents();
        this.onSlideChanged();
        this.updateIndicatorMode();
        return;
      }

      const enableTransitionAnimation = this.dataset.transitionAnimation === 'true';

      this.swiper = new Swiper(swiperEl, {
        loop: this.dataset.loop === 'true',
        speed: enableTransitionAnimation ? 450 : 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        preventClicks: false,
        preventClicksPropagation: false,
        slidesPerView: 1,
        on: {
          init: () => {
            this.bindEvents();
            this.onSlideChanged();
          },
          slideChange: () => this.onSlideChanged(),
        },
      });
    }

    disconnectedCallback() {
      this.stopTimer(true);
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const dotButton = target.closest('[data-dot-index]');
        if (dotButton && this.contains(dotButton)) {
          this.slideTo(dotButton.getAttribute('data-dot-index'));
          return;
        }

        const tabButton = target.closest('[data-tab-index]');
        if (tabButton && this.contains(tabButton)) {
          this.slideTo(tabButton.getAttribute('data-tab-index'));
          return;
        }

        const playPauseButton = target.closest('[data-play-pause]');
        if (playPauseButton && this.contains(playPauseButton)) {
          event.stopPropagation();
          this.togglePlaybackByUser();
        }
      });

      this.indicatorArea?.addEventListener('mouseenter', () => {
        this.hoverTabs = true;
        this.updateIndicatorMode();
      });

      this.indicatorArea?.addEventListener('mouseleave', () => {
        this.hoverTabs = false;
        this.updateIndicatorMode();
      });

      this.slides.forEach((slide) => {
        if (!this.isVideoSlide(slide)) return;

        const toggle = slide.querySelector('[data-media-toggle]');
        const media = slide.querySelector('.yg-ms__media');

        toggle?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.togglePlaybackByUser();
        });

        media?.addEventListener('click', () => {
          if (slide !== this.activeSlide) return;
          this.togglePlaybackByUser();
        });
      });

      this.isMobileMedia.addEventListener('change', () => {
        this.setIndicatorAreaByViewport();
        this.mountIndicatorToActiveSlide();
        this.updateActiveButtons();
        this.updatePlayPauseUI();
        this.updateIndicatorMode();
      });
      window.addEventListener('resize', () => {
        this.setIndicatorAreaByViewport();
        this.syncExpandedThumb();
      });
    }

    slideTo(index) {
      if (!this.swiper) return;
      this.swiper.slideToLoop(parseInt(index, 10));
    }

    get activeIndex() {
      if (!this.swiper) return 0;
      return this.swiper.realIndex ?? 0;
    }

    get activeSlide() {
      return this.slides[this.activeIndex];
    }

    setIndicatorAreaByViewport() {
      const indicatorSelector = this.isMobileMedia.matches
        ? '[data-indicator-area].hide-pc'
        : '[data-indicator-area].hide-mobile';

      this.indicatorArea = this.querySelector(indicatorSelector) || this.querySelector('[data-indicator-area]');
      this.playPauseButton = this.indicatorArea?.querySelector('[data-play-pause]') || null;
      this.expandedThumb = this.indicatorArea?.querySelector('[data-expanded-thumb]') || null;
      this.leftCapsule = this.indicatorArea?.querySelector('.yg-ms__left-capsule') || null;
      this.tabsInner = this.indicatorArea?.querySelector('.yg-ms__tabs-inner') || null;
      this.dotButtons = Array.from(this.indicatorArea?.querySelectorAll('[data-dot-index]') || []);
      this.tabButtons = Array.from(this.indicatorArea?.querySelectorAll('[data-tab-index]') || []);
    }

    isVideoSlide(slide) {
      return slide?.dataset.slideType === 'video';
    }

    togglePlaybackByUser() {
      this.pausedByUser = !this.pausedByUser;
      this.updatePlayPauseUI();
      this.applyPlaybackState();
    }

    getActiveVideoComponent(slide) {
      if (!slide) return null;
      return slide.querySelector('.yg-ms__snippet-video');
    }

    getActiveNativeVideo(slide) {
      const videoComponent = this.getActiveVideoComponent(slide);
      if (!videoComponent) return null;

      const videos = Array.from(videoComponent.querySelectorAll('video.yg-video-iframe'));
      return videos.find((video) => video.offsetParent !== null) || videos[0] || null;
    }

    updateIndicatorMode() {
      if (this.isMobileMedia.matches) {
        this.dataset.indicatorState = 'tabs';
        return;
      }

      if (!this.isVideoSlide(this.activeSlide)) {
        this.dataset.indicatorState = 'tabs';
        return;
      }

      if (this.pausedByUser || this.hoverTabs) {
        this.dataset.indicatorState = 'tabs';
      } else {
        this.dataset.indicatorState = 'dots';
      }
    }

    updateActiveButtons() {
      const index = this.activeIndex;
      this.dotButtons.forEach((button, dotIndex) => {
        button.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      this.tabButtons.forEach((button, tabIndex) => {
        button.setAttribute('aria-current', tabIndex === index ? 'true' : 'false');
      });
      this.syncExpandedThumb();
    }

    syncExpandedThumb() {
      if (!this.expandedThumb) return;
      const activeTab = this.tabButtons[this.activeIndex];
      if (!activeTab) return;
      if (this.leftCapsule && this.tabsInner) {
        this.leftCapsule.style.setProperty('--yg-ms-tabs-width', `${this.tabsInner.scrollWidth + 12}px`);
      }
      this.expandedThumb.style.width = `${activeTab.offsetWidth}px`;
      this.expandedThumb.style.transform = `translateX(${activeTab.offsetLeft}px)`;
      this.centerActiveTab(activeTab);
    }

    centerActiveTab(activeTab) {
      if (!this.isMobileMedia?.matches || !this.tabsInner) return;

      const maxScroll = this.tabsInner.scrollWidth - this.tabsInner.clientWidth;
      if (maxScroll <= 0) return;

      const targetScroll = activeTab.offsetLeft - (this.tabsInner.clientWidth - activeTab.offsetWidth) / 2;
      const nextScroll = Math.max(0, Math.min(targetScroll, maxScroll));
      this.tabsInner.scrollTo({
        left: nextScroll,
        behavior: 'smooth',
      });
    }

    updatePlayPauseUI() {
      if (!this.playPauseButton) return;

      const state = this.pausedByUser ? 'paused' : 'playing';
      const label = this.pausedByUser
        ? this.playPauseButton.dataset.playLabel
        : this.playPauseButton.dataset.pauseLabel;
      this.playPauseButton.dataset.state = state;
      this.playPauseButton.setAttribute('aria-pressed', this.pausedByUser ? 'false' : 'true');
      this.playPauseButton.setAttribute('aria-label', label || '');

      const currentSlideToggle = this.activeSlide?.querySelector('[data-media-toggle]');
      if (currentSlideToggle) {
        const toggleLabel = this.pausedByUser
          ? currentSlideToggle.dataset.playLabel
          : currentSlideToggle.dataset.pauseLabel;
        currentSlideToggle.setAttribute('aria-label', toggleLabel || '');
      }
    }

    onSlideChanged() {
      const activeSlide = this.activeSlide;
      this.stopAllVideos(activeSlide);
      this.mountIndicatorToActiveSlide();
      this.updateActiveButtons();
      this.updateIndicatorMode();
      this.applyPlaybackState(true);
    }

    mountIndicatorToActiveSlide() {
      if (!this.indicatorArea) return;

      const activeSlide = this.activeSlide;
      if (!activeSlide) return;

      const mediaSlot = activeSlide.querySelector('[data-indicator-slot="media"]');
      const contentSlot = activeSlide.querySelector('[data-indicator-slot="content"]');
      const shouldUseContentSlot = this.isMobileMedia.matches && this.dataset.mobileIndicatorInMedia !== 'true';
      const nextParent = shouldUseContentSlot ? contentSlot || mediaSlot : mediaSlot || contentSlot;

      if (!nextParent || this.indicatorArea.parentElement === nextParent) return;
      nextParent.appendChild(this.indicatorArea);
    }

    stopAllVideos(exceptSlide = null) {
      this.slides.forEach((slide) => {
        if (slide === exceptSlide) return;
        this.pauseActiveVideo(slide);
      });
    }

    async getDurationForSlide(slide) {
      if (!slide) return 0;

      if (slide.dataset.slideType === 'video') {
        const videoComponent = this.getActiveVideoComponent(slide);
        if (videoComponent?.playVideo) {
          videoComponent.playVideo();
        }

        const video = this.getActiveNativeVideo(slide);
        if (!video) return 0;

        if (!Number.isFinite(video.duration) || video.duration <= 0) {
          await new Promise((resolve) => {
            video.onloadedmetadata = () => resolve();
          });
        }
        return Math.max(video.duration || 0, 1);
      }

      const speed = parseFloat(slide.dataset.autoplaySpeed || this.dataset.autoplayDefault || '5');
      return Math.max(speed, 1);
    }

    applyPlaybackState(restart = false) {
      const slide = this.activeSlide;
      if (!slide) return;

      if (this.pausedByUser) {
        this.pauseActiveVideo(slide);
        this.pauseTimer();
        this.updateIndicatorMode();
        return;
      }

      this.playActiveVideo(slide, restart);
      this.resumeOrStartTimer(slide, restart);
      this.updateIndicatorMode();
    }

    async resumeOrStartTimer(slide, restart) {
      const duration = await this.getDurationForSlide(slide);
      if (duration <= 0) return;

      if (restart || !this.timerDuration || this.remainingDuration <= 0) {
        this.startTimer(duration);
      } else {
        this.resumeTimer();
      }
    }

    playActiveVideo(slide, restart) {
      if (slide.dataset.slideType !== 'video') return;
      const videoComponent = this.getActiveVideoComponent(slide);
      if (videoComponent?.playVideo) {
        videoComponent.playVideo();
      }

      const video = this.getActiveNativeVideo(slide);
      if (!video) return;

      if (restart) {
        video.currentTime = 0;
      }
      video.play().catch(() => {});
    }

    pauseActiveVideo(slide) {
      if (slide.dataset.slideType !== 'video') return;
      const videoComponent = this.getActiveVideoComponent(slide);
      if (videoComponent?.pauseVideo) {
        videoComponent.pauseVideo();
        return;
      }

      const video = this.getActiveNativeVideo(slide);
      if (video) video.pause();
    }

    startTimer(durationInSeconds) {
      this.stopTimer(true);
      this.timerDuration = durationInSeconds * 1000;
      this.remainingDuration = this.timerDuration;
      this.startStamp = performance.now();
      this.tick();
    }

    resumeTimer() {
      if (this.tickId || this.remainingDuration <= 0) return;
      this.startStamp = performance.now();
      this.tick();
    }

    pauseTimer() {
      if (!this.tickId) return;
      const elapsed = performance.now() - this.startStamp;
      this.remainingDuration = Math.max(this.remainingDuration - elapsed, 0);
      cancelAnimationFrame(this.tickId);
      this.tickId = null;
    }

    stopTimer(resetProgress) {
      if (this.tickId) {
        cancelAnimationFrame(this.tickId);
        this.tickId = null;
      }
      if (resetProgress) {
        this.timerDuration = 0;
        this.remainingDuration = 0;
        this.updateProgress(0);
      }
    }

    tick() {
      const elapsed = performance.now() - this.startStamp;
      const consumed = this.timerDuration - this.remainingDuration + elapsed;
      const ratio = this.timerDuration > 0 ? Math.min(consumed / this.timerDuration, 1) : 0;
      this.updateProgress(ratio);

      if (elapsed >= this.remainingDuration) {
        this.remainingDuration = 0;
        this.tickId = null;
        this.updateProgress(1);
        if (this.swiper && !this.pausedByUser) {
          this.swiper.slideNext();
        }
        return;
      }

      this.tickId = requestAnimationFrame(() => this.tick());
    }

    updateProgress(ratio) {
      const progress = Math.max(0, Math.min(ratio, 1));

      this.dotButtons.forEach((button, idx) => {
        const circle = button.querySelector('[data-progress-bar]');
        if (!circle) return;
        const circumference = circle.getTotalLength();

        if (idx !== this.activeIndex) {
          circle.style.strokeDasharray = `0 ${circumference}`;
          return;
        }

        circle.style.strokeDasharray = `${circumference * progress} ${circumference}`;
      });

      const playRing = this.playPauseButton?.querySelector('[data-play-progress-ring]');
      if (!playRing) return;
      const playRingCircumference = playRing.getTotalLength();
      playRing.style.strokeDasharray = `${playRingCircumference * progress} ${playRingCircumference}`;
    }
  }

  if (!window.customElements.get('yg-media-swiper')) {
    window.customElements.define('yg-media-swiper', YGMediaSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGNav extends YGUtils {
      #sectionsEl;

      constructor() {
        super();
        this.observer = null;
        this.visibleAtc = new Set();
        this.boundOnVariantChange = this.onVariantChange.bind(this);
        this.boundOnClick = this.onClick.bind(this);
        this.boundOnScroll = this.onScroll.bind(this);
        this.boundOnDocumentClick = this.onDocumentClick.bind(this);
      }

      get $sectionsEl() {
        if (this.#sectionsEl) return this.#sectionsEl;
        this.#sectionsEl = {
          atcForm:
            document.querySelector('product-info [is="product-form"]') ||
            document.querySelector('product-rerender [is="product-form"]'),
          sectionEl: this.closest('.shopify-section'),
          topBar: this.querySelector('.yg-nav-top'),
          bottomBar: this.querySelector('.yg-nav-bottom'),
        };
        return this.#sectionsEl;
      }

      connectedCallback() {
        this.observeAtcForm();
        this.syncVisibilityState();
        document.addEventListener('variant:change', this.boundOnVariantChange);
        this.addEventListener('click', this.boundOnClick);
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        document.addEventListener('click', this.boundOnDocumentClick);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        document.removeEventListener('variant:change', this.boundOnVariantChange);
        this.removeEventListener('click', this.boundOnClick);
        window.removeEventListener('scroll', this.boundOnScroll);
        document.removeEventListener('click', this.boundOnDocumentClick);
      }

      setActiveState(isActive) {
        if (isActive) {
          this.$sectionsEl.sectionEl?.classList.add('active');
          this.$sectionsEl.topBar?.classList.add('active');
          this.$sectionsEl.bottomBar?.classList.add('active');
        } else {
          this.$sectionsEl.sectionEl?.classList.remove('active');
          this.$sectionsEl.topBar?.classList.remove('active');
          this.$sectionsEl.bottomBar?.classList.remove('active');
        }
      }

      syncVisibilityState() {
        const atcForm = this.$sectionsEl.atcForm;
        if (!atcForm) return;

        const rect = atcForm.getBoundingClientRect();
        const hasPassedAtc = rect.bottom <= 0;
        this.setActiveState(hasPassedAtc);
      }

      onScroll() {
        this.syncVisibilityState();
      }

      onDocumentClick(event) {
        const openedDetails = this.querySelector('.yg-nav-variant-dropdown[open]');
        if (!openedDetails) return;

        const isClickInsideDropdown = event.target.closest('.yg-nav-variant-dropdown');
        if (!isClickInsideDropdown) {
          openedDetails.removeAttribute('open');
        }
      }

      observeAtcForm() {
        if (!this.$sectionsEl.atcForm || !this.$sectionsEl.bottomBar) return;
        if (this.observer) this.observer.disconnect();

        this.observer = new IntersectionObserver(
          () => {
            this.syncVisibilityState();
          },
          {
            root: null,
            threshold: 0.1,
          }
        );

        this.observer.observe(this.$sectionsEl.atcForm);
      }

      onVariantChange() {
        this.visibleAtc.clear();
        this.#sectionsEl = null;
        this.observeAtcForm();
        this.syncVisibilityState();

        this.getLatestDom((html) => {
          const sectionEl = this.closest('.shopify-section');
          if (!sectionEl) return;
          const latestBar = html.querySelector(`#${sectionEl.id} .yg-nav-bottom`);
          const currentBar = this.querySelector('.yg-nav-bottom');
          if (latestBar && currentBar) {
            currentBar.replaceWith(latestBar.cloneNode(true));
            this.#sectionsEl = null;
            this.observeAtcForm();
            this.syncVisibilityState();
          }
        });
      }

      onClick(event) {
        const addToCart = event.target.closest('.yg-nav-button-add');
        const buyNow = event.target.closest('.yg-nav-button-buy');
        const variantOption = event.target.closest('.yg-nav-variant-option');

        if (variantOption) {
          this.selectVariant(variantOption);
          return;
        }

        if (addToCart) {
          const addToCartButton =
            document.querySelector('product-info product-form [type="submit"]') ||
            document.querySelector('product-rerender product-form [type="submit"]') ||
            document.querySelector('product-info [is="product-form"] [type="submit"]') ||
            document.querySelector('product-rerender [is="product-form"] [type="submit"]');
          if (addToCartButton) addToCartButton.click();
        }

        if (buyNow) {
          const buyNowButton =
            document.querySelector('product-info .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-info shopify-buy-it-now-button .shopify-payment-button__button') ||
            document.querySelector('product-rerender .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-rerender shopify-buy-it-now-button .shopify-payment-button__button');
          if (buyNowButton) buyNowButton.click();
        }
      }

      selectVariant(variantOption) {
        const selectedTitle = variantOption.getAttribute('data-variant-title');
        const selectedId = variantOption.getAttribute('data-variant-id');
        if (!selectedTitle) return;

        const optionsText = selectedTitle.split('/').map((item) => item.trim());
        const forms = document.querySelectorAll('.variant-picker fieldset.variant-picker__option');
        let isSelectedFromLabels = false;

        if (forms.length > 0) {
          forms.forEach((form) => {
            const labels = form.querySelectorAll('label');
            labels.forEach((label) => {
              optionsText.forEach((text) => {
                const span = label.querySelector('span');
                if (span && span.innerText === text) {
                  label.click();
                  isSelectedFromLabels = true;
                }
              });
            });
          });
        }

        if (!isSelectedFromLabels && selectedId) {
          const idInput =
            document.querySelector('product-info [is="product-form"] [name="id"]') ||
            document.querySelector('product-rerender [is="product-form"] [name="id"]');
          if (idInput) {
            idInput.value = selectedId;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const currentTitle = this.querySelector('.yg-nav-variant-current');
        if (currentTitle) {
          currentTitle.textContent = selectedTitle;
        }

        this.querySelectorAll('.yg-nav-variant-option').forEach((item) => {
          item.classList.toggle('active', item === variantOption);
        });

        const details = variantOption.closest('.yg-nav-variant-dropdown');
        if (details) {
          details.removeAttribute('open');
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          this.syncVisibilityState();
        }, 420);
      }
    }

    if (!window.customElements.get('yg-nav')) {
      window.customElements.define('yg-nav', YGNav);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGVideoList01 extends HTMLElement {
      constructor() {
        super();
        this.playbackMode = this.getAttribute('data-playback-mode');
        this.isMobile = window.innerWidth <= 1024;
      }

      connectedCallback() {
        this.slideItems = this.querySelectorAll('.yg-slide-item');
        this.initSoundToggle();
        if (this.playbackMode === 'hover') {
          if (!this.isMobile) {
            this.initHoverPlayback();
          } else {
            this.initMobilePlaybackWhenVisible();
          }
        }
      }

      initSoundToggle() {
        this.slideItems.forEach((item) => {
          const btn = item.querySelector('.yg-video-sound-toggle');
          if (!btn) return;

          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const videoEl = item.querySelector('yg-video');
            if (!videoEl) return;

            this.ensureVideoReady(videoEl);

            const videos = videoEl.querySelectorAll('video.yg-video-iframe');
            const isCurrentlyMuted = !btn.classList.contains('is-unmuted');

            videos.forEach((video) => {
              video.muted = !isCurrentlyMuted;
            });

            btn.classList.toggle('is-unmuted', isCurrentlyMuted);
            btn.setAttribute('aria-pressed', isCurrentlyMuted ? 'true' : 'false');
          });
        });
      }

      ensureVideoReady(videoEl) {
        const tpl = videoEl.querySelector('template');
        if (tpl && !videoEl.querySelector('.yg-video-iframe-container')) {
          videoEl.appendChild(tpl.content.cloneNode(true));
        }

        const container = videoEl.querySelector('.yg-video-iframe-container');
        if (container && !container.dataset.ygPrepared) {
          container.dataset.ygPrepared = 'true';
          container.classList.add('close');
        }

        const videos = videoEl.querySelectorAll('video.yg-video-iframe');
        videos.forEach((video) => {
          video.autoplay = false;
          video.muted = true;
          video.preload = 'metadata';
          video.removeAttribute('autoplay');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          if (!video.dataset.ygEndedCoverBound) {
            video.dataset.ygEndedCoverBound = 'true';
            video.addEventListener('ended', () => {
              this.pauseVideo(videoEl, false, true);
            });
          }
        });

        return container;
      }

      initHoverPlayback() {
        this.slideItems.forEach((item) => {
          const videoEl = item.querySelector('yg-video');
          if (!videoEl) return;

          item.addEventListener('mouseenter', () => {
            this.playVideo(videoEl);
          });

          item.addEventListener('mouseleave', () => {
            this.pauseVideo(videoEl);
          });
        });
      }

      initMobileSwipePlayback() {
        const swiperEl = this.querySelector('yg-swiper');
        if (!swiperEl) return;

        const waitForSwiper = () => {
          if (swiperEl.swiper) {
            this.setupMobileSlideEvents(swiperEl.swiper);
          } else {
            requestAnimationFrame(waitForSwiper);
          }
        };
        waitForSwiper();
      }

      initMobilePlaybackWhenVisible() {
        if (!('IntersectionObserver' in window)) {
          this.initMobileSwipePlayback();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            this.initMobileSwipePlayback();
          },
          { rootMargin: '300px 0px' }
        );

        observer.observe(this);
      }

      setupMobileSlideEvents(swiper) {
        this.currentMobileIndex = swiper.realIndex || 0;

        const firstSlide = swiper.slides[swiper.activeIndex];
        if (firstSlide) {
          const videoEl = firstSlide.querySelector('yg-video');
          if (videoEl) this.playVideo(videoEl);
        }

        swiper.on('slideChangeTransitionStart', () => {
          const prevSlide = swiper.slides[swiper.previousIndex];
          if (prevSlide) {
            const prevVideoEl = prevSlide.querySelector('yg-video');
            if (prevVideoEl) this.pauseVideo(prevVideoEl, true);
          }
        });

        swiper.on('slideChangeTransitionEnd', () => {
          this.currentMobileIndex = swiper.realIndex;
          const activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            const activeVideoEl = activeSlide.querySelector('yg-video');
            if (activeVideoEl) this.playVideo(activeVideoEl);
          }
        });
      }

      playVideo(videoEl) {
        const container = this.ensureVideoReady(videoEl);
        const image = videoEl.querySelector('.yg-video-placeholder');

        if (container) {
          container.classList.remove('close');
        }
        image?.classList.add('close');

        const btn = videoEl.querySelector('.yg-video-button');
        if (btn) btn.classList.add('hide');

        const slideItem = videoEl.closest('.yg-slide-item');
        const soundBtn = slideItem?.querySelector('.yg-video-sound-toggle');
        const isUnmuted = soundBtn?.classList.contains('is-unmuted') ?? false;

        const videos = videoEl.querySelectorAll('video.yg-video-iframe');
        videos.forEach((video) => {
          video.muted = !isUnmuted;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {});
          }
        });
      }

      pauseVideo(videoEl, keepFrame, resetTime = false) {
        const videos = videoEl.querySelectorAll('video.yg-video-iframe');
        videos.forEach((video) => {
          video.pause();
          if (resetTime) {
            video.currentTime = 0;
          }
        });

        if (keepFrame) return;

        const image = videoEl.querySelector('.yg-video-placeholder');
        image?.classList.remove('close');

        const btn = videoEl.querySelector('.yg-video-button');
        if (btn) btn.classList.remove('hide');
      }
    }

    if (!window.customElements.get('yg-video-list-01')) {
      window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
